import * as application from "./application";
import * as campaigns from "./campaigns";
import * as clientProfile from "./client-profile";
import * as conditionals from "./conditionals";
import * as dates from "./dates";
import * as documents from "./documents";
import * as emailIntegration from "./email-integration";
import * as form from "./form";
import * as helpers from "./helpers";
import * as markup from "./markup";
import * as money from "./money";
import * as objects from "./objects";
import * as segments from "./segments";
import * as stripe from "./stripe";
import * as settings from "./settings";
import * as text from "./text";
import * as theme from "./theme";
export default {
  register(Handlebars) {
    application.registerHandlebarHelpers(Handlebars);
    campaigns.registerHandlebarHelpers(Handlebars);
    clientProfile.registerHandlebarHelpers(Handlebars);
    conditionals.registerHandlebarHelpers(Handlebars);
    dates.registerHandlebarHelpers(Handlebars);
    documents.registerHandlebarHelpers(Handlebars);
    emailIntegration.registerHandlebarHelpers(Handlebars);
    form.registerHandlebarHelpers(Handlebars);
    helpers.registerHandlebarHelpers(Handlebars);
    markup.registerHandlebarHelpers(Handlebars);
    money.registerHandlebarHelpers(Handlebars);
    objects.registerHandlebarHelpers(Handlebars);
    segments.registerHandlebarHelpers(Handlebars);
    stripe.registerHandlebarHelpers(Handlebars);
    settings.registerHandlebarHelpers(Handlebars);
    text.registerHandlebarHelpers(Handlebars);
    theme.registerHandlebarHelpers(Handlebars);
  }
};